<template>
  <BaseListItem>
    <BaseListItemContent>
      <a
        v-if="postType !== 'short_post' && postType !== 'picture_post'"
        :href="postUrl"
        target="blank"
      >
        <BaseListItemSubtitle class="d-flex align-center">
          <span class="text-caption font-weight-regular text--secondary mr-2">
            {{ postTypeText }}
          </span>
          <BaseIcon :size="10" class=" text--secondary">
            {{ postTypeIcon }}
          </BaseIcon>
        </BaseListItemSubtitle>
      </a>
      <BaseListItemSubtitle v-else class="d-flex align-center">
        <span class="text-caption font-weight-regular text--secondary mr-2">
          {{ postTypeText }}
        </span>
        <BaseIcon :size="10" class=" text--secondary">
          {{ postTypeIcon }}
        </BaseIcon>
      </BaseListItemSubtitle>
      <!-- Title -->
      <a
        v-if="postType !== 'short_post' && postType !== 'picture_post'"
        :href="postUrl"
        target="blank"
      >
        <div class="text-body-1 font-weight-medium text--primary">
          {{ title }}
        </div>
      </a>
      <div v-else class="text-body-1 font-weight-medium text--primary">
        {{ title }}
      </div>
      <!-- Themes -->
      <div v-if="themes.length" class="mt-1">
        <span
          v-for="ambiance in ambiances.slice(0, 2)"
          :key="ambiance.id"
          class="text-caption font-weight-regular"
        >
          {{ `${ambiance.nameFr}, ` | firstLetterUppercase }}
        </span>
        <span v-if="travellers.length" class="text-caption font-weight-regular">
          {{ `${travellers[0].nameFr}, ` | firstLetterUppercase }}
        </span>
        <span
          v-for="activity in activities.slice(0, 2)"
          :key="activity.id"
          class="text-caption font-weight-regular"
        >
          {{ `${activity.nameFr}, ` | firstLetterUppercase }}
        </span>
        <span v-if="transports.length" class="text-caption font-weight-regular">
          {{ `${transports[0].nameFr}, ` | firstLetterUppercase }}
        </span>
        <!-- and x others -->
        <span
          v-if="
            themes.length >
              ambiances.slice(0, 2).length +
                travellers.length +
                activities.slice(0, 2).length +
                transports.length
          "
          class="text-caption font-weight-regular"
        >
          et
          {{
            themes.length -
              (ambiances.slice(0, 2).length +
                travellers.length +
                activities.slice(0, 2).length +
                transports.length)
          }}
          autre{{
            themes.length -
              (ambiances.slice(0, 2).length +
                travellers.length +
                activities.slice(0, 2).length +
                transports.length) >
            1
              ? "s"
              : ""
          }}
        </span>
      </div>
      <!-- Description Section -->
      <div v-if="postType === 'short_post'">
        <BaseDivider class="my-2"></BaseDivider>
        <div class="text-body-2 font-weight-regular text--primary text-left">
          {{
            content.length > 150 && !this.seeMoreContent
              ? `${content.slice(0, 150)} ...`
              : content
          }}
          <a
            v-if="content.length > 150"
            @click="seeMoreContent = !seeMoreContent"
            class="text-caption font-weight-medium primary--text"
          >
            {{ this.seeMoreContent ? "Voir moins" : "Lire la suite" }}
          </a>
        </div>
      </div>
    </BaseListItemContent>
  </BaseListItem>
</template>

<script>
export default {
  name: "TheExperienceCardContent",
  // DATAs
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    themes: {
      type: Array,
      default: () => []
    },
    postType: {
      type: String,
      required: true
    },
    website: {
      type: String,
      required: true
    },
    postUrl: {
      type: String,
      required: true
    },
    ambiances: {
      type: Array,
      default: () => []
    },
    travellers: {
      type: Array,
      default: () => []
    },
    activities: {
      type: Array,
      default: () => []
    },
    transports: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      seeMoreContent: false
    };
  },
  computed: {
    postTypeIcon() {
      switch (this.postType) {
        case "external_link":
          return "fas fa-external-link-alt";
        case "youtube":
          return "fab fa-youtube";
        case "short_post":
          return "fas fa-edit";
        case "picture_post":
          return "$geopic";
      }
      return "";
    },
    postTypeText() {
      switch (this.postType) {
        case "external_link":
        case "youtube":
          return this.website;
        case "short_post":
          return "Billet Gemmici";
        case "picture_post":
          return "Geopic";
      }
      return "";
    }
  }
};
</script>
